export const LEADERBOARD_ACTION_PERSIST = "LEADERBOARD_PERSIST";
export const LEADERBOARD_ACTION_CLEAR = "LEADERBOARD_CLEAR";
